export const name = 'isEmpty';
/**
 * Determines if value is empty
 *
 * @param value Value to make determination against
 */
const isNotEmpty = async (value) => (!!value && value.trim().length !== 0);
isNotEmpty.defaultMessage = 'Field cannot be empty.';
export { isNotEmpty };
